<script>
import productCardMixin from '@/v-shop/mixins/product-card-mixin'

export default {
	lang: 'shop',
	mixins: [productCardMixin],
	cssVars: {
		selector: '.product-card',
	},
}
</script>

<template>
	<!--  VERTICAL CARD -->
	<div
		v-if="verticalCard"
		:class="['h100', smallWrapperClass]"
		v-click-outside="forMobileShop && onLinkBlurMobile"
	>
		<v-hover v-model="hover">
			<v-card
				:hover="!outOfStock"
				elevation="2"
				@click="cardClick"
				:ripple="false"
				:class="[
					'd-flex flex-column rounded-md overflow-hidden base product-card',
					$bem('product-card-design5-small'),
					alignment == 'left' ? 'text-start' : alignment == 'center' ? 'text-center' : 'text-end',
					{ 'card-border': cardBorder },
				]"
				:style="{ height: forMobileShop && hasHoverAction && hover ? 'calc(100% + 50px)' : '100%' }"
			>
				<div :class="[$bem('__image-cont'), { 'no-stock': outOfStock }, 'mx-2 mt-2']">
					<Media
						cover
						:class="$bem('__main-image')"
						:src="mainImage"
						width="100%"
						aspect-ratio="1"
						:imgClass="
							$b.mt
								? 'product-card-design5-small__image--smallWidth-mobile'
								: 'product-card-design5-small__image--smallWidth'
						"
					/>
					<div v-if="secondImage && hover && imgHover" :class="$bem('__second-image-cont')">
						<Media
							cover
							:src="secondImage"
							width="100%"
							:class="[$bem('__second-image'), hover ? $bem('__second-image--show') : '']"
							:imgClass="
								$b.mt
									? 'product-card-design5-small__image--smallWidth-mobile'
									: 'product-card-design5-small__image--smallWidth'
							"
						/>
					</div>

					<LimitedTimeOffer
						:product="product"
						v-if="hasLimitedTimeOffer"
						:class="$bem('__offer', 'px-1')"
						textAlign="end"
					/>

					<CollectionEventIcon :product="product" :class="$bem('__event-icon')" imgWidth="25px" />
				</div>

				<div
					:class="[
						$bem('__data-cont'),
						'd-flex flex-column mx-2',
						{
							'no-stock': outOfStock,
							h100: hasVisibleAction,
						},
					]"
					style="gap: 6px"
				>
					<ProductCardPrice
						:product="product"
						:currency="currency"
						:priceAmount="price"
						:prevPriceAmount="prevPrice"
						:discountPct="discountPct"
						:containerClass="[
							'd-flex align-center line-clamp-1 px-1 mt-2',
							{ 'justify-center': alignment == 'center', 'justify-end': alignment == 'right' },
						]"
						:prevPriceClass="[$bem('__prev-price'), 'grey--text mr-1 font-0']"
						:priceClass="[$bem('__price'), 'price font-3 line-clamp-1']"
						:discountClass="[$bem('__discount'), 'discount pa-2']"
						:elementOrder="{ prevPrice: 1, price: 2 }"
					/>

					<ProductCard-FinancingTag />

					<ProductCard-TextTag />

					<ProductCard-Tags class="font-0" />

					<ProductCard-AttrsTags />

					<router-link :to="productRoute" custom v-slot="{ navigate, href }">
						<a
							class="card-anchor header"
							@click="forMobileShop ? onLinkClickMobile(navigate, $event) : navigate($event)"
							:href="href"
						>
							<div
								:class="[
									$bem('__name'),
									'line-clamp-2 font-1 header px-1',
									{ 'pb-1': !mobileBtn && !brand },
								]"
							>
								{{ product.name }}
							</div>
						</a>
					</router-link>

					<ProductCard-VariantSelector />

					<div
						v-if="brand"
						:class="[$bem('__brand'), 'font-0 line-clamp-1 px-1', { 'mb-1': !mobileBtn }]"
					>
						{{ brand }}
					</div>

					<ProductCardRating :product="product" />

					<v-spacer />

					<ProductCard-Actions />

					<ProductWishlistToggler
						:productId="product.id"
						:class="[$bem('__wishlist-toggler'), { 'no-stock': outOfStock }]"
						style="z-index: 1"
					/>
				</div>
			</v-card>
		</v-hover>
	</div>
	<!-- END OF VERTICAL CARD -->

	<!-- HORIZONTAL CARD -->
	<div
		v-else
		:class="[
			'w100 product-card--horizontal',
			{
				'product-card-design5-small-horizontal-wrapper-forBtn': hasHoverAction,
				'product-card--align-right': alignment == 'right',
				'product-card--align-center': alignment == 'center',
			},
		]"
		v-click-outside="forMobileShop && onLinkBlurMobile"
	>
		<v-hover v-model="hover">
			<v-card
				:hover="!outOfStock"
				outlined
				@click="cardClick"
				:ripple="false"
				:class="[
					'd-flex overflow-hidden base product-card py-2',
					$bem('product-card-design5-small-horizontal'),
					{ 'product-card-design5-small-horizontal-forBtn': hasAction, 'card-border': cardBorder },
				]"
			>
				<div
					:class="[
						$bem('__image-cont', 'col col-5 pa-0 d-flex flex-column justify-center'),
						{ 'no-stock': outOfStock },
					]"
				>
					<div class="h100 p-relative">
						<Media
							:class="$bem('__main-image', 'px-1 h100')"
							:src="mainImage"
							width="100%"
							imgClass="product-card-design5-small-horizontal__image--smallWidth"
						/>
						<div v-if="secondImage && hover && imgHover" :class="$bem('__second-image-cont', 'h100')">
							<Media
								:src="secondImage"
								width="100%"
								:class="[
									$bem('__second-image', 'h100'),
									hover ? $bem('__second-image--show') : '',
									'h100',
								]"
								imgClass="product-card-design5-small-horizontal__image--smallWidth"
							/>
						</div>
					</div>

					<LimitedTimeOffer
						:product="product"
						textAlign="end"
						class="pa-1 line-clamp-1"
						:class="$bem('__offer')"
					/>

					<CollectionEventIcon :product="product" :class="$bem('__event-icon')" imgWidth="30px" />
				</div>

				<div
					class="col col-7 py-0 pl-1 d-flex flex-column justify-center"
					:class="[$bem('__data-cont'), { 'no-stock': outOfStock, 'my-5': !hasAction }]"
					style="gap: 3px"
				>
					<ProductCardPrice
						:class="$bem('__price-container')"
						:product="product"
						:currency="currency"
						:priceAmount="price"
						:prevPriceAmount="prevPrice"
						:discountPct="discountPct"
						:containerClass="['d-flex align-center line-clamp-1', { 'mt-5': !hasAction }]"
						:prevPriceClass="['grey--text font-0 mr-1', $bem('__prev-price')]"
						:priceClass="[$bem('__price'), 'price font-4 line-clamp-1']"
						:discountClass="[$bem('__discount'), 'discount pa-2']"
						horizontalCard
						:elementOrder="{ prevPrice: 1, price: 2 }"
					/>

					<ProductCard-FinancingTag />

					<ProductCard-TextTag />

					<ProductCard-Tags class="font-0" />

					<ProductCard-AttrsTags :vertical-card="false" />

					<router-link :to="productRoute" custom v-slot="{ navigate, href }">
						<a
							class="card-anchor header"
							@click="forMobileShop ? onLinkClickMobile(navigate, $event) : navigate($event)"
							:href="href"
						>
							<div
								:class="[
									$bem('__name'),
									'line-clamp-2 font-2 header',
									{ 'pb-2': !hasAction && !brand },
								]"
							>
								{{ product.name }}
							</div>
						</a>
					</router-link>

					<ProductCard-VariantSelector />

					<div :class="[$bem('__brand'), 'font-0 line-clamp-1', { 'pb-2': !hasAction }]" v-if="brand">
						{{ brand }}
					</div>
					<ProductWishlistToggler
						:productId="product.id"
						:class="[$bem('__wishlist-toggler'), { 'no-stock': outOfStock }]"
						style="z-index: 1"
						:height="30"
						:width="30"
					/>

					<ProductCardRating :product="product" />

					<v-spacer />

					<ProductCard-Actions />
				</div>
			</v-card>
		</v-hover>
	</div>
	<!-- END OF HORIZONTAL CARD -->
</template>

<style lang="scss" scoped>
.card-border {
	border: 1px solid #b2b2b2;
}

.no-stock {
	opacity: 0.4;
}

// VERTICAL CARD CLASSES
.product-card-design5-small-wrapper {
	// min-height: 270px;
	width: 100%;
	min-width: 100px;

	&-forBtn {
		// min-height: 270px;
		width: 100%;
		min-width: 100px;
		padding-bottom: 50px;
	}
}

.product-card-design5-small-wrapper-mobile {
	width: 90%;

	&-forBtn {
		width: 90%;
	}
}

.product-card-design5-small {
	position: relative;
	cursor: pointer;

	&__image-cont {
		position: relative;
	}

	&__second-image-cont {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}

	&__second-image {
		transition: opacity 0.3s;
		opacity: 0;
		&--show {
			opacity: 1;
		}
	}

	&__offer {
		position: absolute;
		bottom: -4px;
	}

	&__event-icon {
		position: absolute;
		bottom: -8px;
		left: 0;
		z-index: 1;
		width: 25px;
	}

	&__name,
	&__brand {
		display: -webkit-box;
	}

	&__wishlist-toggler {
		position: absolute;
		top: 6px;
		right: 6px;
		z-index: 1;
	}
}

::v-deep .product-card-design5-small {
	.alignment-center {
		position: relative;
		left: 50%;
		transform: translateX(-50%);
	}

	.alignment-right {
		float: right;
	}

	&__discount {
		position: absolute;
		z-index: 1;
		top: 0;
		left: 0;
		border-bottom-right-radius: 4px;
	}

	&__image--smallWidth {
		min-width: 180px;
		min-height: 180px;
		width: 100%;
		height: 100%;
		left: 50% !important;
		top: 50% !important;
		transform: translate(-50%, -50%) !important;
	}

	&__image--smallWidth-mobile {
		max-width: 170px;
		max-height: 170px;
		width: 100%;
		left: 50% !important;
		top: 50% !important;
		transform: translate(-50%, -50%) !important;
	}
}

// HORIZONTAL CARD CLASSES
.product-card-design5-small-horizontal {
	// height: 200px;

	// &-forBtn {
	// 	height: 240px;
	// }

	height: 100%;

	&__image-cont {
		position: relative;
		width: 200px;
	}

	&__second-image-cont {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
	}

	&__second-image {
		transition: opacity 0.3s;
		opacity: 0;
		&--show {
			opacity: 1;
		}
	}

	&__offer {
		position: absolute;
		bottom: 8px;
		border-top-right-radius: 6px;
		border-bottom-right-radius: 6px;
	}

	&__event-icon {
		position: absolute;
		bottom: 5px;
		left: 6px;
		z-index: 1;
		width: 25px;
	}

	&__name,
	&__brand {
		display: -webkit-box;
	}

	&__wishlist-toggler {
		position: absolute;
		top: 7px;
		right: 6px;
		z-index: 1;
	}
}

::v-deep div.product-card-design5-small-horizontal {
	&__image--smallWidth {
		width: 80%;
		left: 50%;
		transform: translateX(-50%);
		height: auto;
	}

	&__prev-price {
		display: -webkit-box;
		column-gap: 8px;
	}

	&__discount {
		font-size: 1.1rem;
		position: absolute;
		z-index: 1;
		top: 0;
		left: 0;
		border-bottom-right-radius: 4px;
	}

	&__price {
		display: -webkit-box;
	}
}
</style>

